<template>
  <aside
    id="cookies-policy"
    class="cookies"
    data-testid="cookie-banner"
    :class="{ 'cookies--show': isRevealed }"
    v-if="!cookieAccepted"
  >
    <div class="cookies__alert">
      <div class="cookies__container cookies__container" v-if="!isRevealed">
        <div class="cookies__wrapper">
          <h2 class="cookies__title">Our website uses cookies</h2>
          <div class="cookies__intro">
            <p>
              We use cookies to gather and store data in order to track and
              improve our website's performance. Click OK if you consent to our
              cookie collection policy.
            </p>
            <p>
              Find out more in our
              <a
                href="https://www.splitthebills.co.uk/privacy-policy"
                data-testid="cookie-privacy-policy-link"
                target="_blank"
                >privacy policy</a
              >.
            </p>
          </div>
          <div class="cookies__actions">
            <input
              type="hidden"
              name="_token"
              value="ZnONgRrpaPuUibDYUsHKwa3Xmsg4jVrBjmnXJMp7"
              autocomplete="off"
            />
            <button
              type="submit"
              class="cookiesBtn__link"
              data-testid="cookiesAccept"
              @click="acceptAll"
            >
              <span class="cookiesBtn__label">OK</span>
            </button>
          </div>
        </div>
      </div>
      <a
        href="#cookies-policy-customize"
        data-testid="cookies-policy-customize-show"
        @click="setExpanded"
        :class="isRevealedClassName"
      >
        <span>Your cookie options</span>
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M14.7559 11.9782C15.0814 11.6527 15.0814 11.1251 14.7559 10.7996L10.5893 6.63297C10.433 6.47669 10.221 6.3889 10 6.38889C9.77899 6.38889 9.56703 6.47669 9.41075 6.63297L5.24408 10.7996C4.91864 11.1251 4.91864 11.6527 5.24408 11.9782C5.56951 12.3036 6.09715 12.3036 6.42259 11.9782L10 8.40074L13.5774 11.9782C13.9028 12.3036 14.4305 12.3036 14.7559 11.9782Z"
            fill="#2C2E30"
          ></path>
        </svg>
      </a>
      <div
        class="cookies__expandable cookies__expandable--custom cookies__expandable--open"
        id="cookies-policy-customize"
        data-testid="cookies-policy-customize-hide"
        v-if="isRevealed"
      >
        <section id="cookies__customize--form" class="cookies__customize">
          <input
            type="hidden"
            name="_token"
            value="ZnONgRrpaPuUibDYUsHKwa3Xmsg4jVrBjmnXJMp7"
            autocomplete="off"
          />
          <div class="cookies__sections--intro">
            <p>
              Split the Bills and our third-party tools use cookies to help
              monitor our website's performance.
            </p>
          </div>

          <div class="cookies__sections" style="max-height: 50vh;">
            <div class="cookies__section">
              <label
                for="cookies-policy-check-essentials"
                class="cookies__category"
              >
                <input type="hidden" name="categories[]" value="essentials" />
                <input
                  type="checkbox"
                  name="categories[]"
                  value="essentials"
                  id="cookies-policy-check-essentials"
                  :checked="basicCookie"
                  disabled="disabled"
                  data-testid="cookies-policy-required-input"
                />
                <span class="cookies__box">
                  <strong class="cookies__label"
                    >I want the basics (necessary cookies)</strong
                  >
                </span>
                <p class="cookies__info">
                  We collect the minimum data needed to provide you with basic
                  functionality.
                </p>
              </label>
            </div>
            <div class="cookies__section">
              <label
                for="cookies-policy-check-analytics"
                class="cookies__category"
              >
                <input
                  type="checkbox"
                  name="categories[]"
                  value="analytics"
                  id="cookies-policy-check-analytics"
                  :checked="personalCookie"
                  v-model="personalCookie"
                  data-testid="cookies-policy-optional-input"
                />
                <span
                  class="cookies__box"
                  data-testid="cookies-policy-optional-input-span"
                >
                  <strong class="cookies__label"
                    >I want a more personal experience</strong
                  >
                </span>
                <p class="cookies__info">
                  We use your data to monitor the performance of our website,
                  continue to improve it for you, and bring you a more personal
                  searching experience.
                </p>
              </label>
            </div>
          </div>

          <div class="cookies__sections--bullet_points">
            <p>Why do we use cookies?</p>
            <ul>
              <li>To understand where users come on to our site from.</li>
              <li>To learn where we can make improvements and develop.</li>
              <li>To study user behaviour on our site.</li>
            </ul>
          </div>

          <div class="cookies__sections--footer">
            <p>
              Find out more in our
              <a
                href="https://www.splitthebills.co.uk/privacy-policy"
                target="_blank"
                data-testid="expanded-cookie-privacy-policy-link"
                >privacy policy</a
              >.
            </p>

            <p></p>
          </div>
        </section>
        <div class="cookies__save">
          <button
            @click="saveSelection"
            class="cookiesBtn__link outline"
            data-testid="saveCookies"
          >
            Save selection
          </button>
          <section class="cookiesBtn cookiesBtn--accept">
            <input
              type="hidden"
              name="_token"
              value="ZnONgRrpaPuUibDYUsHKwa3Xmsg4jVrBjmnXJMp7"
              autocomplete="off"
            />
            <button
              @click="acceptAll"
              class="cookiesBtn__link"
              data-testid="expandedCookiesAccept"
            >
              <span class="cookiesBtn__label">Accept all</span>
            </button>
          </section>
        </div>
      </div>
    </div>
  </aside>
</template>

<script lang="js">

export default {
  name: "CookieBanner",
  computed: {
    isRevealed: {
      get() {
        return this.$store.state.cookieBannerExpanded;
      }
    },
    isRevealedClassName: {
      get() {
        return `cookies__btn cookies__btn--customize ${ this.$store.state.cookieBannerExpanded ? 'banner__expanded' : 'rotate__svg' }`;
      }
    },
    cookieAccepted: {
      get() {
        const currentSession = this.$cookies.get("stb_cookie_consent");
        return !!(currentSession && currentSession.basic === true);
      }
    },
    basicCookie: {
      get() {
        return this.$store.state.cookieState.basic;
      }
    },
    personalCookie: {
      get() {
        return this.$store.state.cookieState.personal;
      },
      set(value) {
        this.$store.commit("COOKIE_ENABLE_PERSONAL_EXPERIENCE", value);
      }
    }
  },
  methods: {
    setExpanded() {
      this.$store.commit("SET_COOKIE_BANNER_EXPANDED");
    },
    setCookie(cookieState) {
      const hostname = window.location.hostname;
      const isLocalhost = hostname === 'localhost';
      const domain = isLocalhost ? hostname : '.splitthebills.co.uk';
      const secure = !isLocalhost;

      // Vue-cookies expects parameters in this order: keyName, value, expires, path, domain, secure, sameSite
      this.$cookies.set("stb_cookie_consent", cookieState, 86400 * 90, "/", domain, secure, "Lax");

      location.reload();
    },
    saveSelection() {
      this.setCookie(this.$store.state.cookieState);
      location.reload();
    },
    acceptAll() {
      this.setCookie({ basic: true, personal: true });
      location.reload();
    },
  }
}
</script>

<style lang="scss">
$gray900: #111928;
$uhOrange: #23a455;
$breakPoint: 767px;

body:has(#cookies-policy.cookies.cp-visible),
.cookie-disable-body-scroll {
  overflow-y: hidden;
}

.cp-hidden {
  display: none;
}

#cookies-policy.cookies {
  font-size: 16px;
  position: fixed;
  bottom: 0;
  right: 0;
  max-height: 100%;
  max-width: 100%;
  overflow: auto;
  z-index: 9999;
  transition: transform 200ms ease-out, opacity 200ms ease-out;
  top: 0;
  left: 0;
  background: rgba(17, 25, 40, 0.65);

  &--closing {
    opacity: 0;
    transform: translateY(10px);
  }

  &--show {
    .cookies {
      &__alert {
        @media only screen and (max-width: $breakPoint) {
          position: relative;
          border-radius: unset;
          border: unset;
          padding-bottom: 152.5px;
        }
      }
    }

    .cookies__btn {
      &--customize {
        border-top: 1px solid #e5e7eb;
        border-bottom: none;
        padding-top: 1em;
        padding-bottom: 0;

        &.banner__expanded {
          border-bottom: 1px solid #e5e7eb;
          border-top: none;
          padding-bottom: 1em;
          padding-top: 0;
        }
      }

      &.rotate__svg {
        svg {
          transform: rotate(180deg);
        }
      }
    }
  }

  &--no-js {
    .cookies__section .cookies__expandable,
    .cookies__expandable:target {
      height: auto;
      visibility: visible;
      opacity: 1;
      transition: height 300ms ease-out, opacity 300ms ease-out;
    }

    .cookies__details {
      display: none;
    }

    .cookies__sections {
      max-height: fit-content;
    }

    svg {
      display: none;
    }
  }
}

#cookies-policy .cookies {
  &__expandable {
    display: block;
    overflow: hidden;
    height: 0;
    visibility: hidden;
    opacity: 0;
    transition: height 200ms ease-out, opacity 200ms ease-out,
      visibility 0s 200ms linear;

    &--open {
      height: auto;
      visibility: visible;
      opacity: 1;
      transition: height 200ms ease-out, opacity 200ms ease-out;
    }
  }

  &__alert {
    width: 33em;
    max-width: 90%;
    margin: 4%;
    padding: 1.5em;
    background: #fff;
    border-radius: 16px;
    border: 1px solid #ffffff;
    -webkit-box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.05),
      0px 10px 15px -3px rgba(0, 0, 0, 0.1);
    -moz-box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.05),
      0px 10px 15px -3px rgba(0, 0, 0, 0.1);
    box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.05),
      0px 10px 15px -3px rgba(0, 0, 0, 0.1);

    position: fixed;
    bottom: 0;
    right: 0;

    @media only screen and (max-width: $breakPoint) {
      max-width: 100%;
      max-height: 100%;
      width: 100%;
      margin: unset;
      border-radius: 8px 8px 0px 0px;
      padding: 1.5em 1em;
      border-top: 2px solid #ffffff;
    }

    @media only screen and (min-width: $breakPoint) {
      margin: 1.55%;
    }
  }

  &__container {
    display: block;
    overflow: hidden;
    height: auto;
    visibility: visible;
    opacity: 1;
    transition: height 200ms ease-out, opacity 200ms ease-out,
      visibility 0s 100ms linear;

    &--hide {
      height: 0;
      visibility: hidden;
      opacity: 0;
      transition: height 200ms ease-out, opacity 200ms ease-out,
        visibility 0s 200ms linear;
    }
  }

  &__wrapper {
    padding-bottom: 1em;
  }

  &__title {
    font-weight: bold;
    line-height: normal;
    font-style: normal;
    margin-bottom: 0.5em;
    font-size: 1em;
    color: $gray900;
    text-align: left;
  }

  &__intro,
  &__sections--footer {
    font-weight: 400;
    font-size: 0.875em;
    line-height: 1.313em;
    font-style: normal;
    color: $gray900;

    p {
      margin-top: 1.5em;

      &:first-child {
        margin-top: 0;
      }
    }

    a {
      text-decoration: underline;
      color: inherit;
      transition: color 200ms ease-out;

      &:hover,
      &:focus {
        color: $uhOrange;
      }
    }
  }

  &__sections--footer {
    padding: 1.5em 0;

    p {
      margin-bottom: 0;
      margin-top: 0;
    }
  }

  &__actions {
    margin-top: 1.5em;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 4px;
  }

  &__btn {
    &--customize {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-weight: 600;
      font-size: 1em;
      line-height: normal;
      text-decoration: none;
      color: $gray900;
      position: relative;
      padding-top: 1.125em;
      border-top: 1px solid #e5e7eb;
    }

    svg {
      transition: transform 200ms ease-out;
    }
  }

  &__sections {
    max-height: 450px;
    overflow-y: auto;

    &--intro,
    &--bullet_points {
      color: $gray900;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 1.313em;
      padding-top: 1.5em;
    }

    &--bullet_points {
      p {
        margin-bottom: 0;
      }

      ul {
        list-style-type: disc;
        list-style-position: outside;
        margin-bottom: 0;
      }
    }
  }

  &__section {
    padding-top: 1.5em;
  }

  &__category,
  &__box {
    display: block;
    position: relative;
    overflow: hidden;
  }

  &__category {
    border: 1px solid #e5e7eb;
    border-radius: 16px;
    padding: 0.5em 1em 1em 1em;

    input {
      position: absolute;
      display: block;
      top: 0;
      right: 105%;
      padding: 0;
      margin: 0;
    }
  }

  &__box {
    padding: 0.5em 3em 0.5em 0;
    line-height: 1.4em;
    cursor: pointer;

    &:before,
    &:after {
      content: "";
      display: block;
      position: absolute;
      top: 50%;
      border-radius: 1.4em;
    }

    &:after {
      right: 0;
      width: 2.5em;
      height: 1.4em;
      margin-top: -0.7em;
      background: #e7e8e9;
      z-index: 0;
      transition: background 200ms ease-out, opacity 200ms ease-out;
    }

    &:before {
      right: 0.75em;
      width: 1em;
      height: 1em;
      margin-top: -0.5em;
      background: #fff;
      z-index: 1;
      transform: translateX(-0.55em);
      transition: transform 200ms ease-out;
    }
  }

  &__category:has(input:checked) {
    border: 1px solid #0e9f6e;
  }

  &__category input:checked + .cookies__box:after {
    background: #0e9f6e;
    opacity: 1;
  }

  &__category input:disabled + .cookies__box:after {
    opacity: 0.6;
  }

  &__category input:checked + .cookies__box:before {
    transform: translateX(0.55em);
  }

  &__label {
    font-size: 0.875em;
    font-weight: 600;
    color: #2c2e30;
  }

  &__info {
    font-weight: 400;
    font-size: 0.875em;
    line-height: 1.313em;
    font-style: normal;
    color: #6b7280;
    margin: 0;
  }

  &__details {
    display: block;
    color: $uhOrange;
    font-size: 0.875em;
    margin: 0.625em 0 0.9em;
    transition: color 200ms ease-out;

    &:hover,
    &:focus {
      color: $uhOrange;
    }
  }

  &__definitions {
    font-size: 0.875em;
    line-height: 1.2em;
    padding-top: 0.8em;
    color: #676767;
  }

  &__cookie + .cookies__cookie {
    margin-top: 1em;
  }

  &__name {
    display: inline;
    font-weight: 600;
    line-height: 22px;
    color: #8a8e92;
  }

  &__duration {
    display: inline;
    text-align: right;
    color: #8a8e92;
  }

  &__description {
    padding-top: 0.3em;
    display: block;
    width: 100%;
    line-height: 120%;
    text-align: left;
    color: #8a8e92;
  }

  &__save {
    border-top: 1px solid #e5e7eb;
    padding-top: 1em;
    display: flex;
    justify-content: flex-end;
    gap: 16px;

    @media only screen and (max-width: $breakPoint) {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 1.5em 1em;
      flex-direction: column-reverse;
      background-color: #fff;
      box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.1);
    }
  }
}

#cookies-policy .cookiesBtn {
  width: 100%;

  &__link {
    display: block;
    font: inherit;
    font-size: 14px;
    font-weight: 600;
    color: #fff;
    background: $uhOrange;
    border: 1px solid $uhOrange;
    border-radius: 8px;
    margin: 0;
    padding: 0.625em 1.25em;
    line-height: 1em;
    text-align: center;
    text-decoration: none;
    height: 3.125em;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
    transition: opacity 200ms ease-out;

    &:hover,
    &:focus {
      opacity: 0.8;
    }

    &.outline {
      border: 1px solid #6b7280;
      background-color: #fff;
      color: #6b7280;
    }
  }
}
</style>
